<template>
  <main>
    <div class="s_i_con" v-if="shopInfo">
      <div class="con_info">
        {{ shopInfo }}
      </div>
    </div>
    <div class="s_i_empty" v-else>
      <div class="empty_img">
        <img
          :src="
            require('@/assets/front/images/v2/profiles/img_default_shop_01.png')
          "
          alt=""
        />
      </div>
      <div class="empty_txt">
        등록된 매장 소개가 없습니다.<br />
        자유롭게 우리 매장을 소개해 보세요!
      </div>
    </div>
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';

export default {
  name: 'ShopIntroduceInfo',
  props: {
    shopInfo: String,
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  async mounted() {},
  computed: {},
  methods: {},
};
</script>
